module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "CHAPTER1",
    attrs: {
      "id": "uQnDLTCpbRWGcYybFsdqO54"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "FIRSTPARAGRAPH"
  }, [_vm._v("I owe a very special round of gratitude to:")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("Eileen O’Callaghan, my loving and supportive wife, who shares life in so many wonderful ways; Matt Bialer, a magician of an agent, and trusted friend; Michaela Hamilton, a conscientious, and extremely talented editor, who is a true delight to work with; Dick Marek, a man from whom I have learned much; Stephen Ohayon, Ph.D., a true gentleman, who inspired me tirelessly from day one; Barry Richman, M.D.; Marla Feder; the Group; and of course, Noreen Nolan, a gifted woman who shares her gift with me.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("Lieutenant William F. Nevins, CDS, Commanding Off­icer of the Queens Homicide Squad, (Retired) for his expert technical advice and skillful guidance. He represents NYPD at its finest.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("My dear friend Priscilla Winkler, whose support through the years has been steadfast.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal _idGenParaOverride-1"
  }, [_vm._v("And to my loving granddaughter, Kristin, who calls me PaPa and watches me melt.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c6029bc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/acknowledgments.vue
// module id = 72
// module chunks = 0